module.exports = __webpack_public_path__ + "img/icon_s-3.2.2e494223.svg";